import 'angular:locale/data:pt';
import 'zone.js';(globalThis.$localize ??= {}).locale = "pt";
